const WORDS = [
  "Architecture",
  "Interiors",
  "Landscape",
  "Consultancy",
  "Site Survey",
  "3D Models",
  "Tender Packages",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      className="relative z-10 select-none border-y border-[#e4e4e2] bg-white py-8"
      data-testid="marquee"
    >
      <div className="ama-marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 text-3xl font-light tracking-tight text-black md:text-5xl">
              {w}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#1B3818]" />
          </span>
        ))}
      </div>
    </section>
  );
}
